module.exports = __webpack_public_path__ + "static/schifffahrt-04c57dd4cb8f58358cb78c71ed4816aa.jpeg";